export class Tuple {
	public Item1: any;
	public Item2: any;
}